let preparedConfig = {
    debugMode: process.env.NODE_ENV === 'development',
    appRoot: '/',
    appBase: '/',
    UI_URL: process.env.VUE_APP_UI_URL,
    ASSETS_URL: process.env.VUE_APP_ASSETS_URL,
    API_URL: process.env.VUE_APP_BASE_API_URL,
    AMIS_API_URL: process.env.VUE_APP_AMIS_BASE_API_URL,
    IS_FABRICATION: process.env.VUE_APP_IS_FABRICATION,
};

export default preparedConfig